export const initBSAFormikValues = {
  username: '',
  password: '',
  comment: '',
};

export const initSimAddonFormikValues = {
  recommendPackage: '',
};

export const initPlantEngineer = {
  plantEngineer: '',
  comment: '',
};

export const initPlantWorkshopManager = {
  plantWorkshopManager: '',
  comment: '',
};

export const initITAdmin = {
  itAdmin: '',
  comment: '',
};

export const initPurchaseOfficer = {
  purchaseOfficer: '',
  comment: '',
};

export const initSimCardValues = {
  reqCapValue: 0,
  mobileNumber: '',
};

export const initNewEmailValues = {
  username: '',
  password: '',
};
